import { cn, Input, Label } from '@up2stay/up2promo-ui';

import { SettingsInfoHint } from '@/core/components/settings/settings-info-hint';

export type ProductFormTargetUrlFieldProps = {
  id: string;
  value: string;
  onChange: (v: string) => void;
  onBlur?: () => void;
  onFocus?: () => void;
  label?: string;
  hint?: string;
  required?: boolean;
  errorMessage?: string;
};

export function ProductFormTargetUrlField({
  id,
  value,
  onChange,
  onBlur,
  onFocus,
  label,
  hint,
  required,
  errorMessage,
}: ProductFormTargetUrlFieldProps) {
  const hasError = !!errorMessage;

  return (
    <div className="space-y-0.5 min-w-0 w-full">
      <div className="flex items-center gap-0.5">
        <Label htmlFor={id}>
          {label}
          {required ? <span className="text-destructive"> *</span> : null}
        </Label>
        {hint && !hasError ? (
          <SettingsInfoHint label={label ?? 'URL'}>{hint}</SettingsInfoHint>
        ) : null}
      </div>
      <Input
        id={id}
        type="text"
        inputMode="url"
        autoComplete="url"
        autoCapitalize="none"
        autoCorrect="off"
        spellCheck={false}
        value={value}
        onChange={(e) => onChange(e.target.value)}
        onBlur={onBlur}
        onFocus={onFocus}
        placeholder="https://…"
        aria-invalid={hasError}
        aria-describedby={hasError ? `${id}-error` : undefined}
        className={cn(
          hasError &&
            'border-destructive focus-visible:border-destructive focus-visible:ring-destructive/30',
        )}
      />
      {hasError ? (
        <p id={`${id}-error`} className="text-xs text-destructive">
          {errorMessage}
        </p>
      ) : null}
    </div>
  );
}
